import { InvoiceStatus } from "@bemap/utils"
import { Tag } from "@chakra-ui/react"

export function renderInvoiceStatus(status: InvoiceStatus) {
  switch (status) {
    case InvoiceStatus.OPEN:
      return 'EM ABERTO'
    case InvoiceStatus.PAID:
      return 'PAGO'
    case InvoiceStatus.OVERDUE:
      return 'ATRASADA'
    case InvoiceStatus.CANCELLED:
      return 'CANCELADA'
  }
}

export function renderInvoiceStatusTag(status: string) {
  switch (status) {
    case 'EM ABERTO':
      return <Tag size={'sm'} colorScheme={'yellow'}>{status}</Tag>
    case 'PAGO':
      return <Tag size={'sm'} colorScheme={'green'}>{status}</Tag>
    case 'ATRASADA':
      return <Tag size={'sm'} colorScheme={'red'}>{status}</Tag>
    case 'CANCELADA':
      return <Tag size={'sm'} colorScheme={'gray'}>{status}</Tag>
  }
}